import { render } from "./vchfn.vue?vue&type=template&id=73393598&scoped=true"
import script from "./vchfn.vue?vue&type=script&lang=js"
export * from "./vchfn.vue?vue&type=script&lang=js"

import "./vchfn.vue?vue&type=style&index=0&id=73393598&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73393598"]])

export default __exports__